import { Building2, Briefcase, CarFront, Compass, Crown, HeartPulse, Plane, Route, Users } from "lucide-react";
import { SERVICES } from "@/data/destinations";
import { useLang } from "@/i18n/LanguageContext";
import Reveal from "@/components/Reveal";

const ICONS = { Building2, Plane, Crown, CarFront, Compass, Route, Users, Briefcase, HeartPulse };
const SPANS = [
  "md:col-span-3", "md:col-span-3",
  "md:col-span-2", "md:col-span-2", "md:col-span-2",
  "md:col-span-2", "md:col-span-2", "md:col-span-2",
  "md:col-span-6 md:col-start-3",
];

export default function Services() {
  const { t } = useLang();
  return (
    <section id="services" className="relative py-28 lg:py-40" data-testid="services-section">
      <div className="mx-auto max-w-[1500px] px-6 lg:px-12">
        <Reveal>
          <p className="eyebrow mb-6">{t("services.eyebrow")}</p>
          <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            <h2 className="max-w-xl font-serif text-4xl font-light leading-tight text-white sm:text-5xl lg:text-6xl">
              {t("services.title")}
            </h2>
            <p className="max-w-sm text-sm font-light leading-relaxed text-white/55 md:text-base">
              {t("services.sub")}
            </p>
          </div>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-5 md:grid-cols-6">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <Reveal key={s.id} delay={(i % 3) * 0.08} className={SPANS[i]}>
                <article
                  data-testid={`service-card-${s.id}`}
                  className="group relative h-full min-h-[220px] overflow-hidden border border-white/10 bg-[#0a1128] transition-colors duration-500 hover:border-[#d4af37]/50"
                >
                  {s.img && (
                    <>
                      <img src={s.img} alt="" loading="lazy" className="img-spotlight absolute inset-0 h-full w-full object-cover opacity-45" />
                      <div className="absolute inset-0 bg-gradient-to-t from-[#050814] via-[#050814]/60 to-[#050814]/20" />
                    </>
                  )}
                  <div className="relative flex h-full flex-col justify-between p-7">
                    <span className="flex h-11 w-11 items-center justify-center border border-[#d4af37]/40 text-[#d4af37] transition-all duration-500 group-hover:bg-[#d4af37] group-hover:text-[#050814]">
                      <Icon size={19} strokeWidth={1.5} />
                    </span>
                    <div>
                      <h3 className="font-serif text-2xl font-light text-white">{t(`svc.${s.id}.t`)}</h3>
                      <p className="mt-2 max-w-xs text-sm font-light leading-relaxed text-white/60">{t(`svc.${s.id}.d`)}</p>
                    </div>
                  </div>
                  <span className="absolute left-0 top-0 h-full w-[2px] origin-top scale-y-0 bg-[#d4af37] transition-transform duration-500 group-hover:scale-y-100" />
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
